var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson24PxOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 2C6.5 3.105 5.605 4 4.5 4C3.395 4 2.5 3.105 2.5 2C2.5 0.895 3.395 0 4.5 0C5.605 0 6.5 0.895 6.5 2ZM0.5 7C0.5 5.67 3.165 5 4.5 5C5.835 5 8.5 5.67 8.5 7V8H0.5V7Z",
    fill: "#FF7C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson24PxOrange);
export default __webpack_public_path__ + "static/media/person_24px_orange.5baa22f6497baae57cb679f9f183c1a6.svg";
export { ForwardRef as ReactComponent };